import styled, { css } from 'styled-components';
import { typographyTokenMapping, getTypographyStyles, getMargins } from '@oneaudi/unified-web-alpha-common';
import { FootnoteStyle } from '../text/index.styles.js';
export const StyledHeadline = styled.div `
  margin: ${(props) => getMargins(props.margin) || 0};
  text-align: ${(props) => props.$textAlign};

  ${(props) => {
    const { type } = props.variant;
    if (type === 'headline') {
        return css `
        color: ${props.theme.sys.color.text.headline.default};
      `;
    }
    return css `
      color: ${props.theme.sys.color.text.display.default};
    `;
}};

  ${(props) => {
    const { type, order } = props.variant;
    const getTokenType = () => {
        if (type === 'headline') {
            const token = typographyTokenMapping.sys.typography.headline['order'][order][props.variant.weight];
            return token;
        }
        const token = typographyTokenMapping.sys.typography.display['order'][order].normal;
        return token;
    };
    return getTypographyStyles(getTokenType());
}};

  ${FootnoteStyle}
`;
//# sourceMappingURL=index.styles.js.map